import { numberToHex } from '../../utils/encoding/toHex.js';
export async function setNonce(client, { address, nonce }) {
    await client.request({
        method: `${client.mode}_setNonce`,
        params: [address, numberToHex(nonce)],
    });
}
//# sourceMappingURL=setNonce.js.map